import {useState, useEffect} from 'react';
import { hoursNow, dateToday, getPermission, viewItemProduct, setMaskDecimal, setMaskGeneric, convertDateAndHour, customFullModal, getParameter, checkIfStringIsFloatAndConvert, showMessageError, formatDecimal, calculateColSpan, custom } from '../../../classes/functions';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArchive, FaArrowAltCircleLeft, FaCog, FaTrash } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import Modal from 'react-modal';
import ReactSignatureCanvas from 'react-signature-canvas';
import ModalFinalizeSeparation from '../../../components/Modal/ModalsRequests/ModalFinalizeSeparation';
import ModalStartSeparation from '../../../components/Modal/ModalsRequests/ModalStartSeparation';
import ModalReverseSeparation from '../../../components/Modal/ModalsRequests/ModalReverseSeparation';
import ModalReverseAproveSeparation from '../../../components/Modal/ModalsRequests/ModalReverseAproveSeparation';
import ModalPauseSeparation from '../../../components/Modal/ModalsRequests/ModalPauseSeparation';
import ModalMakeReturn from '../../../components/Modal/ModalsRequests/ModalMakeReturn';
import ModalFeaturesOpen from '../../../components/Modal/ModalsRequests/ModalFeaturesOpen';
import ModalDeliverSignature from '../../../components/Modal/ModalDeliverSignature/index.js';
import ModalConfirmation from "../../../components/Modal/ModalConfirmation/index.js";
import InputDate from '../../../components/Inputs/Date/index.js';

export default function ProductRequests(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [infos, setInfos] = useState({
    datas: {
      aprovacao: '',
      devolucao: '',
      retirada: '',
      separacao: ''
    },
    data_solicitacao: '',
    hora: '',
    validade: '',
    observacao: '',
    status: '',
    assinatura: {
      extensao: '',
      nome_servidor: '',
      base64: ''
    },
    remetente: 0,
    destino: 0
  });
  const [modalMakeReturn, setModalMakeReturn] = useState(false);
  const [modalSeparationOpenWithoutTag, setSeparationOpenWithoutTag] = useState(false);
  const [modalFeaturesOpen, setModalFeaturesOpen] = useState(false);
  const [modalStartSeparation, setModalStartSeparation] = useState(false);
  const [modalPauseSeparation, setModalPauseSeparation] = useState(false);
  const [modalReverseSeparation, setModalReverseSeparation] = useState(false);
  const [modalFinishSeparation, setModalFinishSeparation] = useState(false);
  const [modalReverseAproveSeparation, setModalReverseAproveSeparation] = useState(false);
  const [showModalUserInformations, setShowModalUserInformations] = useState(false);
  const [showModalSignature, setShowModalSignature] = useState(false);
  const [modalLog, setModalLog] = useState(false);
  const [listStatus, setListStatus] = useState([{label: 'FERRAMENTAS', value: 'FERRAMENTAS'}, {label: 'EPIs', value: 'EPIs'}]);
  const [rows, setRows] = useState([]);
  const [rows_deleted, setRowsDeleted] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersPermissions, setUsersPermissions] = useState([]);
  const [responsavel, setResponsavel] = useState('');
  const [cliente, setCliente] = useState('');
  const [item_form_produto, setItemFormProduto] = useState('');
  const [item_form_quantidade, setItemFormQuantidade] = useState("");
  const [item_form_validade, setItemFormValidade] = useState('');
  const [qtdeProduct, setQtdeProduct] = useState('');
  const [qtdeEngage, setQtdeEngage] = useState('');
  const [qtdeSharedFeature, setQtdeSharedFeature] = useState(0);
  const [qtdeProductFeature, setQtdeProductFeature] = useState(0);
  const [qtdeEngageFeature, setQtdeEngageFeature] = useState(0);
  const [qtdeEngageRequest, setQtdeEngageRequest] = useState(0);
  const [listProducts, setListProducts] = useState([]);
  const [listFeatures, setListFeatures] = useState([]);
  const [listSearchProduct, setListSearchProduct] = useState([]);
  const [listLogSeparation, setListLogSeparation] = useState([]);
  const [conferenceFeatures, setConferenceFeatures] = useState([]);
  const [feature, setFeature] = useState([]);
  const [status, setStatus] = useState('');
  const [solicitante, setSolicitante] = useState('');
  const [data_solicitacao, setDataSolicitacao] = useState('');
  const [hora_solicitacao, setHoraSolicitacao] = useState('');
  const [listReturn, setListReturn] = useState([]);
  const [recebedorId, setRecebedorId] = useState(0);
  const [assinatura, setAssinatura] = useState();
  const [blockQuantity, setBlockQuantity] = useState(false);
  const [label_produto, setLabelProduct] = useState('');
  const [itemId, setItemId] = useState('');
  const [index_aux, setIndex] = useState('');
  const [observation_return, setObservationReturn] = useState(`Devolução de requisição de EPI - ${id}`);
  const tableHeaders = [
    {name: "", validation: ['009'].indexOf(status) > -1},
    {name: "Produto", validation: true, scope: 1},
    {name: "Unidade Medida", validation: true, scope: 1},
    {name: "Característica", validation: true, scope: 1},
    {name: "Quantidade Solicitada", validation: true, scope: 1},
    {name: "Quantidade Separada", validation: true, scope: 1},
    {name: "Quantidade Devolvida", validation: true, scope: 1},
    {name: "Quantidade Eliminada", validation: true, scope: 1},
    {name: "Log", validation: ['004', '005', '006', '007', '008'].indexOf(status), scope: 1},
    {name: "Opções", validation: ['001', '002', '008'].indexOf(status) > -1, scope: 1}
  ];
  const [showModals, setShowModals] = useState({
    confirmDelete: false
  });

  const customStylesSeparation = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      width: '500px',
      maxHeight: '80%',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  const customModalStylesBase = (widthStyle) => {
    return {
        content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        width: widthStyle,
        maxHeight: '80%',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      }
    }
  };
  const customStylesFeatures = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      width: '500px',
      maxHeight: '80%',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  function addItem() {
    if ((label_produto != '') && (item_form_produto != '') && (item_form_quantidade != "") && (item_form_quantidade != "0")) {
      if (getParameter('Validar Estoque') === 'V' && !insertedQuantityIsBiggerThanFeatureQuantity()) {
        toast.error('Não há saldo suficiente para esse produto.');
        return false;
      } else {
        let list_aux = [];
        conferenceFeatures.map((element) => {
          list_aux.push({
            chave: element.chave,
            descricao: element.descricao,
            valor: element.valor,
            id_produto: parseInt(item_form_produto)
          });  
        });
        
        api
        .post("/api/product_requests/setValidateItemsFeatures", {features: list_aux})
        .then((response) => {
          rows?.push({
            id_produto: parseInt(item_form_produto),
            caracteristicas: conferenceFeatures,
            quantidade: checkIfStringIsFloatAndConvert(item_form_quantidade.toString()),
            status: "A",
            validade: item_form_validade?.slice(0, 10)
          });
        
          setRows(rows);
          setSeparationOpenWithoutTag(false);
        })
        .catch((error) => {
          error?.response?.data?.message.map((error) => {
            console.log(error);
            toast.error(error);
          });
          
          setCarrying(false);
        });
      }
    } else {
      toast.error('Preencha todos os campos com * antes de adicionar item.');
    }
  }

  function insertedQuantityIsBiggerThanFeatureQuantity() {
    if (conferenceFeatures.length > 0 && (parseFloat(qtdeProductFeature) + parseFloat(qtdeSharedFeature)) >= (parseFloat(qtdeEngageFeature) + parseFloat(item_form_quantidade) + parseFloat(qtdeEngageRequest))) {
      return true;
    } else if (conferenceFeatures.length == 0 && (parseFloat(qtdeProduct) >= (parseFloat(item_form_quantidade) + parseFloat(qtdeEngageRequest)))) {
      return true;
    } else {
      return false;
    }
  }

  async function getData() {
    await api.get("/api/epi/getDataPage")
          .then((response) => {
            setListProducts(response.data.products);
            setListFeatures(response.data.features);
            setListStatus(response.data.status);
            
            setCarrying(false);
          }).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
  }

  function validForm() {    
    if (rows?.length < 1 || cliente === undefined) {
      toast.error('Preencha todos os campos com * para realizar cadastro.');
      return false;
    } 
    
    return true;
  }

  function searchProduct(e) {
    setLabelProduct(e.target.value);
    var auxListSearchProduct = [];

    listProducts.map((element) => {
      if ((element.codigo_produto?.toUpperCase()?.includes(e.target.value.toUpperCase())) || (element.descricao?.toUpperCase()?.includes(e.target.value.toUpperCase()))) {
        auxListSearchProduct.push(element);
      }
    });
    
    setListSearchProduct(auxListSearchProduct);
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();
     
    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    var data = {
      solicitado_para: parseInt(infos.destino),
      status: status,
      observacao: infos.observacao,
      itens: rows,
      itens_deletar: rows_deleted
    }   

    if (id) { 
      api.put(`/api/epi/product_request/${id}`, data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/epis_requests');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      if(parseInt(infos.destino) !== 0){
        api.post("/api/epi/product_request", data)
        .then((response) => {
            toast.success('Registro inserido com sucesso.');
            history.push('/epis_requests');
          }
        ).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
      } else{
        setCarrying(false);
        toast.error('Por favor, insira um destinatário.');
      }
    }
  }

  function getEPIRequestById(id, option){
    api
    .get(`/api/epi/product_request/${id}`)
    .then((response) => {
      setInfos((prevState) => ({
        ...prevState,
        datas: ({
          ...prevState.datas,
          aprovacao: response.data.data_aprovacao || '',
          devolucao: response.data.data_devolucao || '',
          retirada: response.data.data_retirada || '',
          separacao: response.data.data_separacao || ''
        }),
        data_solicitacao: convertDateAndHour(response.data?.created_at)?.slice(0, 10) || '',
          assinatura: {
            base64: response.data.assinatura.base64,
            extensao: response.data.assinatura.extensao,
            nome_servidor: response.data.assinatura.nome_servidor
          },
          destino: response.data.solicitado_para?.ID,
          observacao: response.data.observacao,
        }));
        
        setSolicitante(response.data.solicitado_por?.ID);
        setHoraSolicitacao(convertDateAndHour(response.data?.created_at)?.slice(11, 19) || '');
        setRecebedorId(response?.data?.recebedor?.ID);
        setStatus(response.data?.status || '001');
        setRows(response.data?.itens || []);
        setRowsDeleted([]);
      })
      .catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
      });
  }

  function cancel(){
    history.push('/epis_requests');
  }

  function remove(){
    api.delete(`/api/epi/product_request/${id}`)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/epis_requests');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function changeItem(e) {
    let aux_list = [];

    rows.forEach((element) => {
      if (element.id == e.target.value) {
        element.checked = !element.checked;
      }

      aux_list.push(element);
    });

    setRows(aux_list);
  }
  
  async function setItemReturn(index, value, field) {
    let aux = [];
    
    listReturn.forEach((element, inx) => {
      if (inx == index) {
        element[field] = setMaskDecimal(value);
      }
      aux.push(element);
    });

    setRows(() => aux);
  }

  function openMakeReturn () {
    let aux_list = [];
    
    rows.map(element => {
      element.id_request = element.id_requisicao.toString();
      if (element.checked) {
        aux_list.push(element);
      }
    });
    
    setListReturn(aux_list);
    
    if (aux_list?.length > 0) {
      setModalMakeReturn(true);
    } else {
      toast.error('Selecione pelo menos um item para devolução.');    
    }
  }

  function setItemList(index, value) {
    let aux = [];
    
    conferenceFeatures.forEach((element, inx) => {
      if (inx == index) {
        element.valor = value.toUpperCase();
      }
      aux.push(element)
    });
    
    setConferenceFeatures(() => aux);
  } 

  function getBalance() {
    let verify_balance = true;
    conferenceFeatures.map((element) => {
      if (element.controls_balance == 'S' && (!element.valor || element.valor == '')) {
        verify_balance = false;
      }
    });
    
    if (verify_balance) {
      let data = {
        data: {
          product: item_form_produto,
          features: conferenceFeatures,
        }
      }
      setBalanceEngageInRequest(item_form_produto);
      api.post("/api/products/getBalanceByProductFeatures", data)
      .then((response) => {
        setQtdeProductFeature(response.data.product);
        setQtdeSharedFeature(response.data.shared);
        setQtdeEngageFeature(response.data.requested);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }
  
  function setBalanceEngageInRequest(product) {
    var sum = 0;
    
    rows.map((element) => {
        if (product == element.id_produto) {
            sum += parseFloat(element.quantidade);
        }
    });
    setQtdeEngageRequest(sum);
  }

  async function selectProduct(value) {
    setLabelProduct(value.codigo_produto + ' - ' + value.descricao);
    setItemFormProduto(value.id);
    setListSearchProduct([]);

    api.get(`/api/products/getFeaturesBalanceByProduct?product=${value.id}&client=${value.id_cliente}`)
    .then((response) => {
      setConferenceFeatures(response.data.features);
      setQtdeProduct(response.data.product);
      setQtdeEngage(response.data.requested);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  async function getDataFeatures(item, index) {
    setFeature(item.caracteristicas);
    setItemId(item);
    setIndex(index);
    setModalFeaturesOpen(true);
  } 

  function saveFeatures() {
    api.put(`/api/epi/product_request/${id}/item/${itemId.id_requisicao}/features`, {caracteristicas: feature})
    .then((response) => {
      rows[index_aux].id_caracteristica_produto = feature;
      setModalFeaturesOpen(false);
    }
    ).catch((error) => {
      error.response.data.error.info.map((error) => {
        console.log(error);
        toast.error(error);
      });
      setCarrying(false);
    });
  }
  
  async function getDataLog(item) {
    api.get(`/api/epi/product_request/${id}/get_logs_separacao_item/${item.id}`)
    .then((response) => {
      setListLogSeparation(response.data);
      setModalLog(true);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  } 

  async function openAddItem() {    
    setItemFormProduto('');
    setItemFormValidade('');
    setLabelProduct('');
    setQtdeProduct('');
    setQtdeEngage('');
    setConferenceFeatures([]);
    setQtdeEngageFeature('');
    setQtdeSharedFeature('');
    setQtdeProductFeature('');
    setQtdeEngageRequest('');
    setItemFormQuantidade(0.00);
    setSeparationOpenWithoutTag(true);
  }

  function finishItem(item) {
    //API original: `/api/product_requests/finishItem?id=${item.id}`
   //API para o futuro: `/api/products_requests/${id}/itens/${item.id}/finalizar`
   
    api.put(`/api/products_requests/${id}/itens/${item.id}/finalizar`)
    .then((response) => {      
      setResponsavel(response.data.row.usuario_responsavel);
      setCliente(response.data.row.cliente.id);
      setStatus(response.data.row.status);
      setInfos((prevState) => ({...prevState, data_solicitacao: response.data.row.data}));
      setHoraSolicitacao(response.data.row.hora);
      setRows(response.data.rows);
      setRowsDeleted([]);
  
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function closeModal() {
    setModalFinishSeparation(false);
    setModalPauseSeparation(false);
    setModalReverseAproveSeparation(false);
    setSeparationOpenWithoutTag(false);
    setModalFeaturesOpen(false);
    setModalMakeReturn(false);
    setModalLog(false);
  }
  
  function removeItem(index) {
    let aux_rows = [];
    let aux_rows_deleted = rows_deleted;

    rows.map((element, idx) => {
      if (idx == index) {
        aux_rows_deleted.push(element);
      } else {
        aux_rows.push(element);
      }
    });

    setRows(aux_rows);
    setRowsDeleted(aux_rows_deleted);
  }

  function getUsers(){
    api
    .get('api/people/getList?funcionario=S')
    .then((response) => {
      let usersArray = [];

      response.data.row.map((user) => {
        if(user.nome_fantasia !== ""){
          usersArray.push({id: user.id, label: user.nome_fantasia, value: user.nome_fantasia});
        }
      });

      setUsers(response.data.row);
      setUsersPermissions(usersArray);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  function postWithdraw(){
    if(!recebedorId){
      return toast.error("O campo recebedor é obrigatório.");
    }

    if(assinatura.isEmpty()){
      return toast.error("A assinatura é obrigatória.");
    }
    
    let data = {
      assinatura: {
        nome: 'Assinatura',
        base64: assinatura?.getTrimmedCanvas()?.toDataURL('image/png')
      },
      recebedor: parseInt(recebedorId)
    }

    api
    .post(`/api/epi/product_request/${id}/withdraw`, data)
    .then((response) => {
      getEPIRequestById(id);
      setShowModalUserInformations(false);
      toast.success('Assinatura realizada com sucesso!');
    })
    .catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function verifyProduct(){
    let hasEPIOrINS = [];
    
    listProducts.map((product) => {
      if(product.codigo_produto === label_produto.split('-')[0].trim()){
        if(product?.tipo === 'EPI' || product?.tipo === 'INS'){
          hasEPIOrINS.push(product)
        }
    }});

    if(hasEPIOrINS.length !== 0){
      setItemFormQuantidade(1);
      setBlockQuantity(true);
    } else{
      setItemFormQuantidade(0);
      setBlockQuantity(false)
    }
  }

  useEffect(()=> {
    getUsers();
    getData();

    async function loadProductRequests(){
      if (id) {
        getEPIRequestById(id, option);
      } else {
        setStatus('001');
        setDataSolicitacao(dateToday);
        setHoraSolicitacao(hoursNow);
      }
    }
    loadProductRequests();
  }, []);

  useEffect(() => {
    verifyProduct();
  }, [label_produto]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      <ModalConfirmation state={showModals.confirmDelete} setState={setShowModals} stateName={'confirmDelete'} custom={custom('500px', '250px')} title={'Deseja realmente excluir esta requisição?'} action={remove} param={''}/>

      <Modal
        isOpen={modalSeparationOpenWithoutTag}
        onRequestClose={closeModal}
        style={customStylesSeparation}
        contentLabel="Conferência"
        ariaHideApp={false}
        keepMounted
      >
          <div>
            {qtdeProduct !== '' && <div><label>Saldo disponível: {qtdeProduct}</label></div>}
            {qtdeEngage !== '' && <div><label>Saldo empenhado: {qtdeEngage}</label></div>}
            <div className="divGroup">
              <div className="formDiv">
                <label>Produto</label>&nbsp;<label className="required">*</label><br/>
                <input type="text" placeholder="Produto" value={label_produto} onChange={searchProduct} maxLength="60" />
                <ul className="dropdown-menu" id="productDatalist">
                  {listSearchProduct.map((item, index) => {
                    return (
                      <li key={index} onClick={() => selectProduct(item)}>
                        <a>{item.codigo_produto} - {item.descricao}</a>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>

            {conferenceFeatures?.length > 0 && conferenceFeatures.map((item, index) => (
              <div className="formDiv" key={index}>
                <label>{item.descricao}</label>&nbsp;{item.mandatory == 'S' && <label className="required">*</label>}<br/>
                <input type="text" placeholder={item.descricao} value={conferenceFeatures[index].valor} onBlur={getBalance} onChange={ (e) => setItemList(index, e.target.value) } maxLength="30" disabled={view}/>
              </div>
            ))} 
            {qtdeProductFeature !== '' && <div><label>Saldo disponível: {qtdeProductFeature}</label></div>}
            {qtdeSharedFeature !== '' && <div><label>Saldo disponível compartilhado: {qtdeSharedFeature}</label></div>}
            {qtdeEngageFeature !== '' && <div><label>Saldo empenhado: {qtdeEngageFeature}</label></div>}
            {qtdeEngageRequest !== '' && <div><label>Saldo empenhado na Requisição: {qtdeEngageRequest}</label></div>}

            <div className="divGroup">
              <div className="formDiv">
                <label>Quantidade</label>&nbsp;<label className="required">*</label><br/>
                <input type="text" value={item_form_quantidade} placeholder="Quantidade" onChange={(e) => setItemFormQuantidade(e.target.value)} maxLength="30" disabled={blockQuantity}/>
              </div>
            </div>

            <div className="divGroup">
              <div className="formDiv">
                <button type="button" className="buttonSubmit inputSm marginRight" onClick={addItem} disabled={view}>Confirmar</button>
                <button type="button" className="buttonCancel inputSm pullRight" onClick={closeModal} disabled={view}>Fechar</button>
              </div>
            </div>
          </div>
      </Modal>

      <ModalDeliverSignature screenName={"EPI"} id={id} showModalDeliverSignature={showModalUserInformations} setShowModalDeliverSignature={setShowModalUserInformations} getOne={getEPIRequestById} option={option} status={status} receiverID={recebedorId} setReceiverID={setRecebedorId} signature={assinatura} setSignature={setAssinatura} base64={infos?.assinatura?.base64?.split("base64,")[1]} users={users} API={`/api/epi/product_request/${id}/withdraw`} method={"post"}/>
      <ModalFeaturesOpen customStylesFeatures={customStylesFeatures} feature={feature} featurePermission={"OPERACOES - REQUISICOES EPIS - ALTERAR VALOR CARACTERISTICA"} listFeatures={listFeatures} modalFeaturesOpen={modalFeaturesOpen} saveFeatures={saveFeatures} setFeature={setFeature} setModalFeaturesOpen={setModalFeaturesOpen} view={view} />
      <ModalFinalizeSeparation customStyles={customFullModal} showModalFinishSeparation={modalFinishSeparation} setShowModalFinishSeparation={setModalFinishSeparation} id={id} rows={rows} setCarrying={setCarrying} setStatus={setStatus} URL={`/api/product_requests/setFinishSeparation?id=${id}`} method={"get"} />
      <ModalStartSeparation customStyles={customFullModal} showModalStartSeparation={modalStartSeparation} setShowModalStartSeparation={setModalStartSeparation} setCarrying={setCarrying} id={id} />
      <ModalReverseSeparation customStyles={customFullModal} modalReverseSeparation={modalReverseSeparation} setModalReverseSeparation={setModalReverseSeparation} id={id} setCarrying={setCarrying} setStatus={setStatus} />
      <ModalReverseAproveSeparation customStyles={customFullModal} modalReverseAproveSeparation={modalReverseAproveSeparation} setCarrying={setCarrying} setStatus={setStatus} id={id} setModalReverseAproveSeparation={setModalReverseAproveSeparation} API={`/api/epi/product_request/${id}/reverse_approval`} APIBody={''} APIMethod={'put'} /> 
      <ModalPauseSeparation modalPauseSeparation={modalPauseSeparation} setModalPauseSeparation={setModalPauseSeparation} setCarrying={setCarrying} setStatus={setStatus} id={id} />
      <ModalMakeReturn customStyles={customFullModal} listProducts={listProducts} listReturn={listReturn} modalMakeReturn={modalMakeReturn} observation_return={observation_return} setItemReturn={setItemReturn} setModalMakeReturn={setModalMakeReturn} setCarrying={setCarrying} setObservationReturn={setObservationReturn} redirect={'/epis_requests'} view={view} id={id} />
      
      <Modal  
        isOpen={modalLog}
        onRequestClose={closeModal}
        style={customFullModal}
        contentLabel="Log"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Usuário</th>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                {listLogSeparation && listLogSeparation?.length > 0 && listLogSeparation.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td>{item?.id}</td>
                      <td>{item?.usuario}</td>
                      <td>{convertDateAndHour(item?.created_at)?.slice(0, 10)}</td>
                      <td>{convertDateAndHour(item?.created_at)?.slice(11, 19)}</td>
                      <td>{item?.descricao}</td>
                    </tr>
                  )
                })}
                {listLogSeparation?.length === 0 && 
                  <tr>
                    <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showModalSignature}
        onRequestClose={() => setShowModalSignature(false)}
        style={customModalStylesBase('900px')}
        contentLabel="Log"
        ariaHideApp={false}
        keepMounted
      >
        <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
          <h1 style={{fontWeight: '400'}}>Assinatura</h1>
          <img src={infos.assinatura.base64} style={{border: '1px solid gray', borderRadius: '5px', height: '20rem'}} />
        </div>
      </Modal>
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando...</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <div className="title" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <div style={{display: 'flex', flexDirection: 'row-reverse', alignItems: 'center'}}>
            <span>Cadastro de Requisição de EPIs</span>
            <Link to="/epis_requests">
              <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
            </Link>
          </div> 
        </div>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais - {id}</h2>
              <hr></hr>

              <div className="divGroup" style={{display: "flex", alignItems: "center"}}>
                  {id &&
                    <>
                    {infos.datas.aprovacao !== '' &&
                      <div className="formDiv">
                        <label>Data de Aprovação</label>&nbsp;<label className="required">*</label><br/>
                        <input type='date' value={infos.datas.aprovacao.split(' ')[0]} onChange={(e) => setInfos(prevState => ({...prevState, datas: ({
                          ...prevState.datas,
                          aprovacao: e.target.value
                        })}))} disabled />
                      </div>
                    }

                    {infos.datas.devolucao !== '' &&
                      <div className="formDiv">
                        <label>Data de Devolução</label>&nbsp;<label className="required">*</label><br/>
                        <input type='date' value={infos.datas.devolucao.split(' ')[0]} onChange={(e) => setInfos(prevState => ({...prevState, datas: ({
                          ...prevState.datas,
                          devolucao: e.target.value
                        })}))} disabled />
                      </div>
                    }

                    {infos.datas.retirada !== '' &&
                      <div className="formDiv">
                        <label>Data de Retirada</label>&nbsp;<label className="required">*</label><br/>
                        <input type='date' value={infos.datas.retirada.split(' ')[0]} onChange={(e) => setInfos(prevState => ({...prevState, datas: ({
                          ...prevState.datas,
                          retirada: e.target.value
                        })}))} disabled />
                      </div>
                    }

                    {infos.datas.separacao !== '' &&
                      <div className="formDiv">
                        <label>Data de Separação</label>&nbsp;<label className="required">*</label><br/>
                        <input type='date' value={infos.datas.separacao.split(' ')[0]} onChange={(e) => setInfos(prevState => ({...prevState, datas: ({
                          ...prevState.datas,
                          separacao: e.target.value
                        })}))} disabled />
                      </div>
                    }
                    </>
                  }        

                <div className="formDiv">
                  <label>Data</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_solicitacao" disabled />
                </div>

                <div className="formDiv">
                  <label>Hora</label><br/>
                  <input type="text" placeholder="##:##:##" value={hora_solicitacao} onChange={ (e) => setHoraSolicitacao(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true}/>
                </div>
                
                <div className="formDiv">
                  <label>Destino</label>&nbsp;<label className="required">*</label><br/>
                  <select value={infos.destino} onChange={(e) => setInfos(prevState => ({...prevState, destino: e.target.value}))} style={{width: "100%"}} disabled={['004', '005', '006', '007', '008', '009'].indexOf(status) > -1}>
                    <option value="">Selecione</option>
                    {usersPermissions.map((user, index) => {
                      return (
                        <option value={user.id} key={index}>{user.label}</option>
                      )
                    })}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Observação</label><br/>
                  <textarea placeholder='Observação' value={infos.observacao} onChange={(e) => setInfos(prevState => ({...prevState, observacao: e.target.value}))} disabled={['004', '005', '006', '007', '008', '009'].indexOf(status) > -1} />
                </div>
                
                <div className="formDiv">
                  <label>Status</label>&nbsp;<label className="required">*</label><br/>
                  <select value={status} onChange={ (e) => setStatus(e.target.value) } style={{width: "100%"}} disabled={true}>
                    {listStatus.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <br/>
          </form>
        </div>
        <br/>
        <div className="divGroup">
          <div className="formDivList">
            <div className="containerGroupData" style={{overflowX: "scroll", maxWidth: "100%"}}>
              <h2>Itens&nbsp;<label className="required">*</label></h2>
              <hr style={{width: `${tableHeaders.filter((tableHeader) => tableHeader.validation).length * 300}px`}}></hr>
              <table>
                <thead>
                  <tr>
                    {tableHeaders.map((tableHeader, index) => {
                      if(tableHeader.validation){
                        return (
                          <th key={index} style={{width: "300px"}} className={tableHeader.name === "Opções" ? "collumOption" : ""} colSpan={tableHeader.scope}>{tableHeader.name}{tableHeader.isRequired && <>&nbsp;<label className="required">*</label></>}</th>
                        )
                      }
                    })}
                  </tr>
                </thead>
                <tbody>
                  {rows?.map((form_item, index) => {
                    return(
                      <tr key={index}>
                        {['009'].indexOf(status) > -1 && <td data-label="#">
                          <input type="checkbox" checked={form_item.checked} value={form_item.id} onChange={changeItem} />
                        </td>}
                        <td>{form_item?.detalhes_produto?.descricao}</td>
                        <td>{form_item?.detalhes_produto?.unidade_medida}</td>
                        <td><button type="button" className="buttonTable" onClick={() => getDataFeatures(form_item, index)}>Ver características</button></td>
                        <td>{form_item.quantidade}</td>
                        <td>{form_item.qtde_separada}</td>
                        <td>{form_item.qtde_devolvida}</td>
                        <td>{form_item.qtde_eliminada}</td>
                        {['004', '005', '006', '007', '008'].indexOf(status) > -1 && <td>
                          <button type="button" className="buttonTable" onClick={() =>  getDataLog(form_item)}>Ver log</button>
                        </td>}
                        {['001', '002', '008'].indexOf(status) > -1 && <td className='collumOption' style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}}>
                            {['001']?.indexOf(status) > -1 && <Link className="action" onClick={() => removeItem(index)}>
                                <FaTrash color="#000" size={17} />
                            </Link>}
                            {getPermission('OPERACOES - REQUISICOES EPIS - ELIMINAR RESÍDUOS') && ['002','008'].indexOf(status) > -1 && form_item.status != 'F' && <Link className="action" style={{marginRight: '2.5rem'}} data-tip="Eliminar Resíduo" onClick={() => finishItem(form_item)}>
                                <ReactTooltip />
                                <FaArchive color="#000" size={17} />
                            </Link>}
                          </td>}
                        </tr>
                      )})}
                      {rows?.length === 0 && <tr>
                        <td colSpan={() => calculateColSpan(tableHeaders)}><label className='required'>Nenhum registro encontrado!</label></td>
                      </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {!view && <div className="formDiv" style={{display: "flex", gap: "0.5rem"}}>
              {['001'].indexOf(status) > -1 && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('OPERACOES - REQUISICOES EPIS - EXCLUSAO') && ['001', '002'].indexOf(status) > -1 && <button type="button" className="buttonRemove" onClick={() => setShowModals((prevState) => ({...prevState, confirmDelete: true}))} disabled={view}>Excluir</button>}
              {['001'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={openAddItem}>Adicionar Item</button>}
            {id && ['006', '007', '009'].indexOf(status) > -1 &&
            <button type='button' onClick={() => setShowModalUserInformations(true)} className="buttonTab">
              {['006'].indexOf(status) > -1 ? 'Entregar' : 'Consultar Entrega'}
            </button>
            }
            {getPermission('OPERACOES - REQUISICOES EPIS - APROVACAO') && ['002'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={() => setModalReverseAproveSeparation(true)}>Estornar Aprovação</button>}
            {getPermission('OPERACOES - SEPARACAO') && ['002','008'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={() => setModalStartSeparation(true)}>Iniciar Separação</button>}
            {getPermission('OPERACOES - SEPARACAO') && localStorage.usuario == responsavel && ['004','005','006'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={() => setModalPauseSeparation(true)}>Pausar Separação</button>}
            {false && getPermission('OPERACOES - REQUISICOES EPIS - ESTORNO') && ['005','006','007'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={() => setModalReverseSeparation(true)}>Estornar</button>}
            {(solicitante == localStorage.usuario || getPermission('OPERACOES - REQUISICAO DEVOLUCAO - SUPER CADASTRO')) && getPermission('OPERACOES - REQUISICOES EPIS - INICIAR DEVOLUCAO') && ['007', '009'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={openMakeReturn}>Solicitar Devolução</button>}
            </div>}
      </div>}
    </div>
  )
}